import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Profile from "./components/Profile";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import ProjectDetail from "./components/ProjectDetail";
import Certifications from "./components/Certifications";
import Experience from "./components/Experience";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Wave from "./components/Wave"; // Import the wave
import ScrollToTopButton from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              {/* Home Section with Wave transition */}
              <div id="home" className="relative">
                <Profile />
                <Wave /> 
              </div>
              
              <div id="about"><About /></div>
              <div id="skills"><Skills /></div>
              <div id="projects"><Projects /></div>
              <div id="certifications"><Certifications /></div>
              <div id="experience"><Experience /></div>
              <div id="contact"><Contact /></div>
            </>
          } />
          <Route path="/project/:id" element={<ProjectDetail />} />
        </Routes>
        <Footer />
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App;